import styled, { css } from 'styled-components';
import { defaultTheme } from "../theme";

export const SectionHeadWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__SectionHeadWrapper", componentId: "sc-zj7zmn-0" })(["display:flex;height:24px;"]);




export const StyledSectionHead = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__StyledSectionHead", componentId: "sc-zj7zmn-1" })(["", " color:", ";flex:1;display:flex;align-items:center;&::after{background-color:", ";content:'';height:4px;flex:1;border-radius:2px;margin-left:", ";}"],
(props) => css(props.theme.typography.SmallCapsHeadline),
(props) => props.theme.colors['Level 5'],





(props) => props.theme.colors['Level 1'],




(props) => props.theme.spacers.M);



StyledSectionHead.defaultProps = {
  theme: defaultTheme };


export const IconContainer = /*#__PURE__*/styled('span').withConfig({ displayName: "styles__IconContainer", componentId: "sc-zj7zmn-2" })(["margin-right:4px;color:", ";"],

(props) => props.theme.colors['Level 5']);


IconContainer.defaultProps = {
  theme: defaultTheme };